import { Dialog } from "primereact/dialog";
import React, { useContext, useEffect, useMemo, useState } from "react";
import LessonsBooking from "../LessonsBooking";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { GlobalContext } from "../../contexts/GlobalContext";

const TrailLessonModal = ({ visible, setVisible }) => {
  const { allSettings } = useContext(GlobalContext);
  const [stripePromise, setStripePromise] = useState(null);
  // const stripePromise = loadStripe(
  //   "pk_test_51PGOx0ILne6s8AtAqrur6XFagaBvkyujVehCUYU82TVJYP5ujv7KI7XqHfaxYBtk5VxPwXc1wfVkFyKoLtrdWgPZ00fzpPmisP"
  // );
  // const stripePromise = loadStripe(
  //   allSettings.find((setting) => setting.name === "stripe_publishable_key")
  //     ?.value || ""
  // );
  useEffect(() => {
    const stripeKey = allSettings.find(
      (setting) => setting.name === "stripe_publishable_key"
    )?.value;

    if (stripeKey) {
      setStripePromise(loadStripe(stripeKey));
    }
  }, [allSettings]);
  // const stripePromise = useMemo(() => {
  //   const stripeKey = allSettings.find(
  //     (setting) => setting.name === "stripe_publishable_key"
  //   )?.value;
  //   return stripeKey ? loadStripe(stripeKey) : null;
  // }, []);
  return (
    <Dialog
      header="Book Trial lesson"
      visible={visible}
      className="w-12 lg:w-6 md:w-8"
      onHide={() => setVisible(false)}
      style={{ width: "100%" }}
    >
      <div>
        <Elements stripe={stripePromise}>
          <LessonsBooking bookingSingleLessonInModal={true} />
        </Elements>
      </div>
    </Dialog>
  );
};

export default TrailLessonModal;
